module.exports = __webpack_public_path__ + "img/sofort.fd936b4c.png";